var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"clickable"},[_c('td',[_vm._v(" "+_vm._s(_vm.role.id)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.role.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }